import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { confirmPasswordReset } from "firebase/auth";
import { auth } from "./firebase";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const oobCode = searchParams.get("oobCode"); // from email link
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleResetPassword = async () => {
    if (!newPassword) return alert("❌ Please enter a new password");
    if (!oobCode) return alert("❌ Invalid or missing reset code");

    setLoading(true);

    try {
      await confirmPasswordReset(auth, oobCode, newPassword);
      alert("✅ Password reset successful! You can now login.");
      navigate("/login");
    } catch (error) {
      console.error(error);
      alert(`❌ Failed to reset password: ${error.message}`);
    } finally {
      setLoading(false);
      setNewPassword("");
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-50 p-4">
      <h2 className="text-2xl font-bold mb-4">Reset Password</h2>
      <input
        type="password"
        placeholder="New Password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        className="border p-2 rounded w-64 mb-4"
      />
      <button
        onClick={handleResetPassword}
        className="bg-green-600 text-white py-2 px-4 rounded hover:bg-green-700 w-64"
        disabled={loading}
      >
        {loading ? "Resetting..." : "Reset Password"}
      </button>
    </div>
  );
};

export default ResetPassword;
